import {
  FENCES_REGION_LIST_WITHOUT_PANEL_MODUL,
  FENCES_REGION_LIST_WITHOUT_PANEL_MODUL_ZHALYUZI,
} from './fences-constants';
import { FencesMainPageType } from './fences-types';

export const getFencesMainPageType = (regionId: string): FencesMainPageType => {
  console.log('REGION_ID: ', regionId);
  if (FENCES_REGION_LIST_WITHOUT_PANEL_MODUL_ZHALYUZI.includes(regionId)) {
    return 'withoutPanelModulZhalyuzi';
  }

  if (FENCES_REGION_LIST_WITHOUT_PANEL_MODUL.includes(regionId)) {
    return 'withoutPanelModul';
  }

  return 'withAll';
};
